import { ApplicationInfo, EnvironmentService } from '@abp/ng.core';
import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-logo',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <a href="/">
      @if (appInfo.logoUrl) {
        <img
          [src]="appInfo.logoUrl"
          [alt]="appInfo.name"
          [ngStyle]="{ minWidth: '40px' }"
          width="50%"
          height="auto"
        />
      } @else {
        {{ appInfo.name }}
      }
    </a>
  `,
  styles: [],
  imports: [NgStyle],
})
export class LogoComponent {
  constructor(
    private elRef: ElementRef,
    private environment: EnvironmentService,
  ) {}

  get appInfo(): ApplicationInfo {
    this.environment.getEnvironment().application.logoUrl = '/assets/images/logo/SitePlant.png';
    return this.environment.getEnvironment().application;
  }
}
